import { history } from 'instantsearch.js/es/lib/routers/index.js'

const allowedRouteProperties = ['page', 'refinementList', 'sortBy']

function pickAllowedProperties(state) {
  if (!state || typeof state !== 'object' || Array.isArray(state)) {
    return {}
  }

  return Object.fromEntries(allowedRouteProperties.filter((property) => state[property] !== undefined).map((property) => [property, state[property]]))
}

export function createProductListingStateMapping(indexName, { includeQuery = false, productIndexId = indexName } = {}) {
  return {
    stateToRoute(uiState = {}) {
      const state = pickAllowedProperties(uiState[productIndexId])
      const query = uiState[indexName]?.query

      if (includeQuery && typeof query === 'string' && query) {
        state.phrase = query
      }

      return state
    },
    routeToState(routeState = {}) {
      const state = { [productIndexId]: pickAllowedProperties(routeState) }

      if (includeQuery) {
        state[indexName] = { ...state[indexName], query: typeof routeState.phrase === 'string' ? routeState.phrase : '' }
      }

      return state
    },
  }
}

export function createProductListingRouting(indexName, options = {}) {
  const routerOptions = { cleanUrlOnDispose: true }

  if (options.includeQuery) {
    // Preserve campaign parameters, but replace (or remove) search-owned parameters.
    routerOptions.createURL = ({ qsModule, location, routeState }) => {
      const parameters = qsModule.parse(location.search.slice(1))

      for (const property of ['phrase', ...allowedRouteProperties]) {
        delete parameters[property]
      }

      const query = qsModule.stringify({ ...parameters, ...routeState })

      return `${location.origin}${location.pathname}${query ? `?${query}` : ''}${location.hash}`
    }
  }

  return { router: history(routerOptions), stateMapping: createProductListingStateMapping(indexName, options) }
}
